import EditIcon from '@mui/icons-material/Edit';
import ImageIcon from '@mui/icons-material/Image';

import { Box, Button, IconButton } from '@mui/material';
import { RefObject, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const ImageSelector = ({ src, onSelect }: { src?: string; onSelect: (e: React.MouseEvent<HTMLElement>, ref: RefObject<HTMLElement | null>) => void }) => {
    const { t } = useTranslation();
    const selectorRef = useRef<HTMLDivElement>(null);

    return (
        <Box
            sx={(theme) => ({
                width: '100%',
                padding: 1,
                borderRadius: 1,
                backgroundColor: (theme.vars || theme).palette.grey[200],
                ...theme.applyStyles('dark', {
                    backgroundColor: (theme.vars || theme).palette.grey[600],
                }),
            })}
            ref={selectorRef}
        >
            {!src ? (
                <Box
                    sx={(theme) => ({
                        p: 1,
                        aspectRatio: 1,
                        borderRadius: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: (theme.vars || theme).palette.grey[100],
                        ...theme.applyStyles('dark', {
                            backgroundColor: (theme.vars || theme).palette.grey[700],
                        }),
                    })}
                >
                    <ImageIcon sx={{ flex: 1, width: '60%', height: '60%', color: (theme) => (theme.vars || theme).palette.grey[400] }} />
                    <Button data-testid='image-selector-select' variant='contained' onClick={(e) => onSelect(e, selectorRef)} fullWidth>
                        {t('slide.legacy.character.selectImage')}
                    </Button>
                </Box>
            ) : (
                <Box
                    sx={(theme) => ({
                        p: 1,
                        borderRadius: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                        backgroundColor: (theme.vars || theme).palette.grey[100],
                        ...theme.applyStyles('dark', {
                            backgroundColor: (theme.vars || theme).palette.grey[700],
                        }),
                    })}
                >
                    <Box
                        component='img'
                        alt='image'
                        src={src}
                        sx={{
                            width: '100%',
                            aspectRatio: '1',
                            objectFit: 'contain',
                        }}
                    />
                    <IconButton data-testid='image-selector-select' sx={{ position: 'absolute', top: 0, right: 0, m: 0.5 }} onClick={(e) => onSelect(e, selectorRef)}>
                        <EditIcon />
                    </IconButton>
                </Box>
            )}
        </Box>
    );
};
